import React from 'react';
import styles from './styles.module.css';
import { useHistory } from 'react-router-dom';

const PageContainerTabs = ({
  titlesLinks,
  activeTab,
  setActiveTab,
  baseAddress,
  noRerender = false,
  /** When true, only updates local state (no history / URL change). */
  skipHistory = false,
}) => {
  const history = useHistory();
  const Badge = (number) => {
    if (number > 0) {
      return (
        <div className={styles.badge}>
          <span>{number}</span>
        </div>
      );
    }
    return '';
  };
  return (
    <div className={styles.tabLinks}>
      {titlesLinks?.map((title, index) => (
        <span
          style={{
            width: title.width,
          }}
          key={index}
          onClick={() => {
            const next = title.pushAddress.toLowerCase();
            setActiveTab(next);
            if (skipHistory) return;
            if (noRerender)
              window.history.pushState(
                null,
                '',
                `#${baseAddress}${title.pushAddress}`
              );
            else history.push(`${baseAddress}${title.pushAddress}`);
          }}
          className={
            activeTab === title.pushAddress.toLowerCase()
              ? styles.tabLinksBtnActive
              : styles.tabLinksBtn
          }>
          {title.title}
          {title.badge > 0 && Badge(title.badge)}
        </span>
      ))}
    </div>
  );
};

export default PageContainerTabs;
